import React, { Component } from 'react';
import { Row, Col, DropdownButton, MenuItem, ButtonToolbar} from 'react-bootstrap';
import { withRouter } from "react-router-dom";
import "src/css/Navigation.css";
import HeaderLogo from 'src/js/HeaderLogo.js';
import 'src/i18n';
import { Trans, withTranslation } from 'react-i18next';

class DriverNavigation extends Component {

  constructor(props) {
    super(props);
    let pathName = props.location.pathname;
    let activeKeyName = '/' + pathName.split('/')[1]

    if ('/login' === activeKeyName || '/' === activeKeyName) {
      activeKeyName = '/top'
    }

    this.state = {
      activeKey: activeKeyName,
      titleName: "Home"
    };

    this.handleSelect = this.handleSelect.bind(this);
    this.resetLocalVehiclesData = this.resetLocalVehiclesData.bind(this);
    this.setTitle = this.setTitle.bind(this);
  }

  componentWillMount(){
    this.setTitle()
  }

  // ドロップダウンリストに表示される文字列を変更するための処理
  setTitle(){
    let title = ""
    switch(this.state.activeKey){
      case "/top":
        title = "Home"
        break;
      case "/trip_report":
        title = "TripReport"
        break;
      case "/monthly_report":
        title = "MonthlyReport"
        break;
      case "/safety_map":
        title = "SafetyMap"
        break;
      case "/ranking":
        title = "Ranking"
        break;
      default :
        title = "";
    }
    this.setState({
      titleName: title
    })
  }
  
  handleSelect(selectedKey) {
    this.props.history.replace(selectedKey);
    this.setState({ activeKey: selectedKey });
    this.resetLocalVehiclesData();
  }

  // Vehicles関連のローカルストレージデータを削除する
  resetLocalVehiclesData() {
    localStorage.removeItem('searchResultData');
  }

  render() {
    return (
      <Row>
        <HeaderLogo />
        <div className="mini-div"></div>
        <Col className="dropdown-transition">
          <ButtonToolbar >
            <DropdownButton
              bsStyle="default"
              title={<Trans i18nKey={"Navigation." + this.state.titleName}>
                      {this.state.titleName}
                    </Trans>}
              id="dropdown-button"
            >
              <MenuItem href={"/top"} key={"Home"}>
                <Trans i18nKey={'Navigation.Home'}>
                  Home
                </Trans>
              </MenuItem>
              <MenuItem href={"/trip_report"}>
                <Trans i18nKey={'Navigation.TripReport'}>
                  TripReport
                </Trans>
              </MenuItem>
              <MenuItem href={"/monthly_report"}>
                <Trans i18nKey={'Navigation.MonthlyReport'}>
                  MonthlyReport
                </Trans>
              </MenuItem>
              <MenuItem href={"/safety_map"}>
                <Trans i18nKey={'Navigation.SafetyMap'}>
                  SafetyMap
                </Trans>
              </MenuItem>
              <MenuItem href={"/ranking"}>
                <Trans i18nKey={'Navigation.Ranking'}>
                  Ranking
                </Trans>
              </MenuItem>
              <MenuItem onClick={this.props.signOut}>
                <Trans i18nKey={'Navigation.Logout'}>
                  Logout
                </Trans>
              </MenuItem>
            </DropdownButton>
          </ButtonToolbar>
        </Col>
      </Row>
    );
  }
}

export default withTranslation()(withRouter(DriverNavigation));



// WEBPACK FOOTER //
// ./src/component/Navigation/DriverNavigation.js